import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { SsoComponent } from './components/sso/sso.component';
import { AuthGuard } from './services/guard/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },{
    path: 'sso',
    component: SsoComponent
  },{
    path: 'verify-otp',
    loadChildren: () => import('./modules/verify-otp/verify-otp.module').then(m => m.VerifyOtpModule)
  },{
    path: 'forgot',
    loadChildren: () => import('./modules/forgot/forgot.module').then(m => m.ForgotModule)
  },{
    path: 'set-password',
    loadChildren: () => import('./modules/set-password/set-password.module').then(m => m.SetPasswordModule),
    canLoad: [AuthGuard]
  },{
    path: '',
    loadChildren: () => import('./modules/front/front.module').then(m => m.FrontModule),
    canLoad: [AuthGuard]
  },{
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
